/*
*   接口配额组件
*/

import { Component } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config.js';
import {
    Row,
    Col,
    message,
    Table,
    Input,
    Select,
    Button,
    Tag,
    theme,
    Space,
    Statistic,
} from 'antd';
import {
    PlusOutlined,
} from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    isGTscreenWidth,
    ShowIPModal,
    GetButtonActionName,
} from '../../incs/FunHelper.js';

import TokenEntity from './TokenEntity.js';

const MODULENAME = CNF.navItems[0].submenu[0].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[0].submenu[0].ptn;


const Lists = (props) => {
    const {
        token: {
            colorPrimary,           // 主色
            colorPrimaryBg,         // 主色浅色背景色
            colorSuccess,
            colorSuccessBg,
            blue1,
            blue6,
            colorError,
            colorErrorBg,

        },
    } = theme.useToken();

    const update = (record) => { props.setOpen(true, record); }

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    const operation = (action, record) => {
        let uri = 'quota/tokens/' + record.key;
        switch (action) {
            case CNF.actionName.UPDATE:
                update(record);
                break;
            case CNF.actionName.DISABLE:
            case CNF.actionName.ACTIVE:
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.group_prefix, action, MODULENAME, props.isRefresh, uri);
                break;
            default:
                break;

        }
    }

    const columns = [
        { title: '', dataIndex: '', key: 'key', fixed: 'left', width: CNF.searchMarginLeft * 4, },
        { title: '组织前缀', dataIndex: 'group_prefix', key: 'group_prefix', },
        {
            title: '总计tokens', key: 'total_tokens',
            render: (record) => <Tag style={{ width: isGTscreenWidth ? '30%' : '40%' }} color={colorPrimaryBg}><Statistic precision={CNF.DPL} suffix={record.total_tokens > 1000000 ? 'M' : 'K'} valueStyle={{ fontSize: CNF.fontSize - 2, color: colorPrimary }} value={record.total_tokens > 1000000 ? record.total_tokens / 1000000 : record.total_tokens / 1000} /></Tag>
        },
        {
            title: '已用tokens', key: 'used_tokens',
            render: (record) => <Tag style={{ width: isGTscreenWidth ? '30%' : '40%' }} color={blue1}><Statistic precision={CNF.DPL} suffix={record.used_tokens > 1000000 ? 'M' : 'K'} valueStyle={{ fontSize: CNF.fontSize - 2, color: blue6 }} value={record.used_tokens > 1000000 ? record.used_tokens / 1000000 : record.used_tokens / 1000} /></Tag>
        },
        {
            title: '可用tokens', key: 'usable_tokens',
            render: (record) => <Tag style={{ width: isGTscreenWidth ? '30%' : '40%' }} color={record.total_tokens - record.used_tokens >= 10000 ? colorSuccessBg : colorErrorBg}><Statistic precision={CNF.DPL} suffix={(record.total_tokens - record.used_tokens) > 1000000 ? 'M' : 'K'} valueStyle={{ fontSize: CNF.fontSize - 2, color: record.total_tokens - record.used_tokens >= 10000 ? colorSuccess : colorError }} value={(record.total_tokens - record.used_tokens) > 1000000 ? (record.total_tokens - record.used_tokens) / 1000000 : (record.total_tokens - record.used_tokens) / 1000} /></Tag>
        },
        { title: '状态', dataIndex: 'status', key: 'status', width: CNF.tableStatusColumnWidth, },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
        { title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', },
        {
            title: '', key: 'operation', fixed: 'right', width: CNF.tableOperationColumnWidth, hidden: (
                props.btnLists.indexOf(MODULENAME_PTN + '_update') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_disable') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_active') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_delete') >= 0
            ) ? false : true,
            render: (record) => GetButtonActionName(props.btnLists, MODULENAME_PTN, record, operation)
        }
    ];
    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={props.dataLists}
                pagination={{
                    showSizeChanger: false,
                    // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                    showQuickJumper: false,
                    showTotal: () => <>共{props.pageCount > 10000 ? (props.pageCount / 10000).toFixed(CNF.DPL) + '万' : props.pageCount}条</>,
                    pageSize: CNF.pageSize,
                    current: props.currentIndex,
                    total: props.pageCount,
                    onShowSizeChange: (current, pageSize) => props.changePageSize(pageSize, current),
                    onChange: (current) => props.changeIndex(current),
                }}
            />
        </>
    );
}

class CPT extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record: null,
            open: false,
            init: 0,
            isRefresh: 0,
            currentIndex: 1,
            pageCount: 0,
            dataLists: [],
            groupPrefix: '',
            role: '',
            scene: '',
            status: CNF.status[0].value,
        }
    }

    isRefresh = () => { this.setState({ isRefresh: this.state.isRefresh === 1 ? 0 : 1 }); }
    search = () => { this.setState({ currentIndex: 1 }); this.isRefresh(); }
    changeGroupPrefix = (e) => { this.setState({ groupPrefix: e.target.value }); this.search(); }
    changeStatus = (value) => { this.setState({ status: value === undefined ? '' : value }); this.search(); }
    changeIndex = (index) => { this.setState({ currentIndex: index }); this.isRefresh(); }

    setOpen = (value, record) => { this.setState({ open: value, record: record }); }
    create = () => { this.setOpen(true, null); }

    /**
     * 获取列表
     */
    getLists() {
        const _this = this;
        const params = {
            'group_prefix': this.state.groupPrefix,
            'status': this.state.status,
            'page_size': CNF.pageSize,
            'current_index': this.state.currentIndex
        };
        $.ajax({
            url: `${CNF.api}quota/tokens${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        _this.setState({
                            dataLists: data.dat,
                            pageCount: data.cnt
                        });
                    } else {
                        _this.setState({
                            dataLists: [],
                            pageCount: 0
                        });
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    componentDidUpdate() {
        if (this.state.init !== this.state.isRefresh) {
            this.getLists();
            this.setState({
                init: this.state.isRefresh
            });
        }
    }

    componentDidMount() {
        this.getLists();
    }

    render() {
        return (
            <>
                <Row style={{ paddingTop: CNF.searchMarginLeft * 4, paddingBottom: CNF.searchMarginLeft * 4, paddingLeft: CNF.searchMarginLeft * 4 }}>
                    <Col span={isGTscreenWidth ? 2 : 3}>
                        <Input
                            onChange={this.changeGroupPrefix}
                            placeholder='组织前缀'
                            value={this.state.groupPrefix}
                        />
                    </Col>
                    <Col span={2} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Select
                            allowClear
                            placeholder='状态'
                            style={{ width: '100%' }}
                            onChange={(value) => setStatus(value)}
                            value={this.state.status ? this.state.status : undefined}
                            options={CNF.status.map((item, index) => ({
                                key: index,
                                value: item.value,
                                label: item.label
                            }))}
                        />
                    </Col>
                    <Space size={CNF.searchMarginLeft} style={{ marginLeft: CNF.searchMarginLeft }}>
                        {
                            this.props.btnLists.indexOf(MODULENAME_PTN + '_create') >= 0 ? (
                                <Button
                                    title={CNF.actionName.CREATE + MODULENAME}
                                    color='primary'
                                    variant='solid'
                                    icon={<PlusOutlined />}
                                    onClick={() => {
                                        this.create();
                                    }}>
                                    {CNF.actionName.CREATE}
                                </Button>
                            ) : ''
                        }
                    </Space>
                    <TokenEntity
                        btnLists={this.props.btnLists}
                        policy={this.props.policy}
                        open={this.state.open}
                        record={this.state.record}
                        setOpen={this.setOpen}
                        isRefresh={this.isRefresh}
                    />
                </Row>
                <Row>
                    <Col span={24}>
                        <Lists
                            btnLists={this.props.btnLists}
                            dataLists={this.state.dataLists}
                            currentIndex={this.state.currentIndex}
                            pageCount={this.state.pageCount}
                            changeIndex={this.changeIndex}
                            setOpen={this.setOpen}
                            isRefresh={this.isRefresh}
                        />
                    </Col>
                </Row>
            </>
        );
    }
}

export default CPT